// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__31CZn","resendInfoText":"OnGoingPaymentBox_resendInfoText__2rV6r"};